module.exports = __webpack_public_path__ + "static/media/internetveloce-logo.8d6687c7.svg";